import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import CardsList from "@/pages/CardsList";
import CardBuilder from "@/pages/CardBuilder";
import ClientAccounts from "@/pages/ClientAccounts";
import ClientAccountSeats from "@/pages/ClientAccountSeats";
import ClientRegister from "@/pages/ClientRegister";
import Directory from "@/pages/Directory";
import AuditLog from "@/pages/AuditLog";
import Analytics from "@/pages/Analytics";
import QRStudio from "@/pages/QRStudio";
import Leads from "@/pages/Leads";
import EmailSignature from "@/pages/EmailSignature";
import PlansGuide from "@/pages/PlansGuide";
import Notifications from "@/pages/Notifications";
import Settings from "@/pages/Settings";
import Billing from "@/pages/Billing";
import Pricing from "@/pages/Pricing";
import PublicCard from "@/pages/PublicCard";
import PaymentResult from "@/pages/PaymentResult";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#8B9BB4]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="bottom-right" theme="dark" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/c/:slug" element={<PublicCard />} />
            <Route path="/d/:regToken" element={<Directory />} />
            <Route path="/join/:regToken" element={<ClientRegister />} />
            <Route path="/payment/success" element={<PaymentResult />} />
            <Route path="/payment/cancel" element={<PaymentResult />} />
            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/app/cards" element={<Protected><CardsList /></Protected>} />
            <Route path="/app/cards/new" element={<Protected><CardBuilder /></Protected>} />
            <Route path="/app/cards/:id" element={<Protected><CardBuilder /></Protected>} />
            <Route path="/app/clients" element={<Protected><ClientAccounts /></Protected>} />
            <Route path="/app/clients/:accId" element={<Protected><ClientAccountSeats /></Protected>} />
            <Route path="/app/analytics" element={<Protected><Analytics /></Protected>} />
            <Route path="/app/audit" element={<Protected><AuditLog /></Protected>} />
            <Route path="/app/studio" element={<Protected><QRStudio /></Protected>} />
            <Route path="/app/leads" element={<Protected><Leads /></Protected>} />
            <Route path="/app/signature" element={<Protected><EmailSignature /></Protected>} />
            <Route path="/app/guide" element={<Protected><PlansGuide /></Protected>} />
            <Route path="/app/notifications" element={<Protected><Notifications /></Protected>} />
            <Route path="/app/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/app/billing" element={<Protected><Billing /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
